import { ApplicationActionType } from '../../../ApplicationConstants';
import { performCellDoubleClick } from './onCellDblClick';

export const onCellDblClickAppraisalReceive = (e) => {
    performCellDoubleClick(e, ApplicationActionType.AppraisalReceive);
};
